import {
  PlatformActivityJournalEntryFragment,
  PlatformFoodJournalEntryFragment,
  PlatformJournalEntryCommentFragment,
  PlatformStoolJournalEntryFragment,
  PlatformSymptomJournalEntryFragment,
  PlatformWaterIntakeJournalEntryFragment,
  PlatformWeightJournalEntryFragment,
} from '@web-app/generated/platform/graphql';

/**
 * Union type of all journal entry fragments.
 * This matches the actual shape of entries returned by the getJournalEntries query.
 */
export type JournalEntry =
  | PlatformFoodJournalEntryFragment
  | PlatformWaterIntakeJournalEntryFragment
  | PlatformSymptomJournalEntryFragment
  | PlatformStoolJournalEntryFragment
  | PlatformWeightJournalEntryFragment
  | PlatformActivityJournalEntryFragment;

export type FoodJournalEntry = PlatformFoodJournalEntryFragment;

export type WaterIntakeJournalEntry = PlatformWaterIntakeJournalEntryFragment;

export type SymptomJournalEntry = PlatformSymptomJournalEntryFragment;

export type StoolJournalEntry = PlatformStoolJournalEntryFragment;

export type WeightJournalEntry = PlatformWeightJournalEntryFragment;

export type ActivityJournalEntry = PlatformActivityJournalEntryFragment;

export type EntryComment = PlatformJournalEntryCommentFragment;
// Helper type guards
export const isFoodEntry = (entry: JournalEntry): entry is FoodJournalEntry =>
  entry.__typename === 'FoodJournalEntry';

export const isWaterEntry = (
  entry: JournalEntry,
): entry is WaterIntakeJournalEntry =>
  entry.__typename === 'WaterIntakeJournalEntry';

export const isSymptomEntry = (
  entry: JournalEntry,
): entry is SymptomJournalEntry => entry.__typename === 'SymptomJournalEntry';

export const isStoolEntry = (entry: JournalEntry): entry is StoolJournalEntry =>
  entry.__typename === 'StoolJournalEntry';

export const isWeightEntry = (
  entry: JournalEntry,
): entry is WeightJournalEntry => entry.__typename === 'WeightJournalEntry';

export const isActivityEntry = (
  entry: JournalEntry,
): entry is ActivityJournalEntry => entry.__typename === 'ActivityJournalEntry';
